module.exports = __webpack_public_path__ + "img/PaulingLinus.5b3466f6.jpg";